import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export const SIDEBAR_WIDTH = 220;

const NAV_ITEMS = [
  {
    to: '/admin',
    label: 'Overview',
    exact: true,
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
  },
  {
    to: '/admin/users',
    label: 'Users',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    to: '/admin/tenders',
    label: 'Tenders',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
  },
  {
    to: '/admin/pipelines',
    label: 'Pipelines',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="22" y1="12" x2="2" y2="12"/>
        <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
        <line x1="6" y1="16" x2="6.01" y2="16"/>
        <line x1="10" y1="16" x2="10.01" y2="16"/>
      </svg>
    ),
  },
  {
    to: '/admin/prospector',
    label: 'Prospector',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="3"/>
        <line x1="12" y1="2" x2="12" y2="5"/>
        <line x1="12" y1="19" x2="12" y2="22"/>
        <line x1="2" y1="12" x2="5" y2="12"/>
        <line x1="19" y1="12" x2="22" y2="12"/>
      </svg>
    ),
  },
];

const s = {
  sidebar: {
    position: 'fixed',
    top: 60,
    left: 0,
    bottom: 0,
    width: SIDEBAR_WIDTH,
    background: '#0c1322',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 200,
    borderRight: '1px solid rgba(255,255,255,0.06)',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  badge: {
    background: '#1e3a5f',
    color: '#60a5fa',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    padding: '3px 8px',
    borderRadius: 4,
    margin: '16px 12px 4px',
    display: 'inline-block',
    alignSelf: 'flex-start',
  },
  section: {
    padding: '8px 12px',
  },
  item: (active) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 10px',
    borderRadius: 7,
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: active ? 500 : 400,
    color: active ? '#fff' : '#94a3b8',
    background: active ? 'rgba(96,165,250,0.12)' : 'transparent',
    marginBottom: 2,
  }),
  iconWrap: (active) => ({
    color: active ? '#60a5fa' : '#475569',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  }),
  divider: {
    borderTop: '1px solid rgba(255,255,255,0.06)',
    margin: '8px 12px',
  },
  backLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 10px',
    margin: '0 12px',
    borderRadius: 7,
    textDecoration: 'none',
    fontSize: 13,
    color: '#475569',
    background: 'transparent',
  },
};

export default function AdminSidebar() {
  const { pathname } = useLocation();

  function isActive(item) {
    return item.exact ? pathname === item.to : pathname.startsWith(item.to);
  }

  return (
    <aside style={s.sidebar}>
      <span style={s.badge}>Admin</span>
      <div style={s.section}>
        {NAV_ITEMS.map((item) => {
          const active = isActive(item);
          return (
            <Link key={item.to} to={item.to} style={s.item(active)}>
              <span style={s.iconWrap(active)}>{item.icon}</span>
              {item.label}
            </Link>
          );
        })}
      </div>
      <div style={s.divider} />
      <Link to="/dashboard" style={s.backLink}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 12H5M12 5l-7 7 7 7"/>
        </svg>
        Back to app
      </Link>
    </aside>
  );
}
